import React from "react";
import "../../css/TopPosterBanner.css";
import poster from "../../assets/harinaam-poster.jpg";
import posterMobile from "../../assets/harinaam-mobile.jpg";
import { useNavigate } from "react-router-dom";

const TopPosterBanner = () => {
  const navigate = useNavigate();

  const handleDownload = () => {
    navigate("/posters");
  };

  const handleUpload = () => {
    navigate("/upload-media");
  };

  return (
    <div className="poster-banner-wrapper">
      <div className="poster-banner-container">

        {/* 🔥 BUTTON GROUP (NOW ABOVE IMAGE) */}
        <div className="button-group">
          <div className="tooltip-wrapper">
            <button
              className="download-btn"
              onClick={handleUpload}
              aria-label="Upload"
            >
              <p>Upload Sankirtan Photos</p>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                viewBox="0 0 24 24" fill="none" stroke="currentColor"
                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="17 8 12 3 7 8" />
                <line x1="12" y1="3" x2="12" y2="15" />
              </svg>
            </button>
            <div className="tooltip">Upload your Sankirtan Photos</div>
          </div>

          <div className="tooltip-wrapper">
            <button
              className="download-btn"
              onClick={handleDownload}
              aria-label="Download"
            >
              <p>Download below Poster</p>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                viewBox="0 0 24 24" fill="none" stroke="currentColor"
                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
            </button>
            <div className="tooltip">
              Download posters in CDR format to edit posters
            </div>
          </div>
        </div>

        {/* 🔥 IMAGE */}
        <div className="poster-image">
          <picture>
            <source media="(max-width: 768px)" srcSet={posterMobile} />
            <img src={poster} alt="Harinaam Sankirtan Poster" />
          </picture>
        </div>

      </div>
    </div>
  );
};

export default TopPosterBanner;